// ============================================================================
// ENUMS
// ============================================================================

export enum MemberInclude {
  SessionData = 'sessionData',
}

// alias for clarity in chat_message

/** member.health_status */
export enum MemberHealthStatus {
  Good = 'Good',
  Laggy = 'Laggy',
  Errored = 'Errored',
}

export const MEMBER_HEALTH_STATUS_VALUES = Object.freeze(Object.values(MemberHealthStatus));

/**
 * Status of a member's outcome in a step execution
 */
export enum MemberOutcomeStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Laggy = 'laggy',
}
